var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuadros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.72327,
    y: 4.10254,
    width: 20.5533,
    height: 16.2263,
    rx: 2,
    stroke: "#CFD0E7",
    strokeWidth: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.53394,
    y: 7.0083,
    width: 14.9334,
    height: 10.5218,
    rx: 0.5,
    stroke: "#CFD0E7",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29492 4.10291C9.29492 2.75948 10.6284 1.67041 12.2733 1.67041",
    stroke: "#CFD0E7",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4144 11.8232L3.30872 18.9291",
    stroke: "#CFD0E7",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7841 16.4062L6.86145 20.329",
    stroke: "#CFD0E7",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuadros);
export default __webpack_public_path__ + "static/media/quadros.9f12fa7876b042fa01b5935368faeab6.svg";
export { ForwardRef as ReactComponent };